import ProductImagesView from "./images/ProductImagesView";

const ImagesView = ({ id }) => {
  return (
    <div className="card">
      <h5>Images</h5>

      <div className="mt-2">
        {id ? (
          <ProductImagesView id={id} />
        ) : (
          <div className="opacity-70">
            Create a product before adding images.
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagesView;
